AdvancedSelectFragment:
  remoteHelp: Indiquez le chemin vers la liste d'options, la valeur et le label.
  remoteHelpMore: Tutoriel.
  remoteHelpTitle: Récupérer les éléments dans les résultats de la source externe
  remoteHelpText: |
    <b>EXEMPLE SIMPLE</b>

    La source externe renvoie des données au format JSON, par exemple :
    <pre>
    {
        "books": [
            {
                "author": "Herman Melville",
                "category": "fiction",
                "isbn": "0-553-21311-3",
                "price": 8.99,
                "title": "Moby Dick"
            },
            {
                "author": "J. R. R. Tolkien",
                "category": "fiction",
                "isbn": "0-395-19395-8",
                "price": 22.99,
                "title": "The Lord of the Rings"
            }
        ]
    }
    </pre>
    La liste des options est toujours dans un tableau, délimité par des crochets <code>[]</code>. Chaque option est délimitée par des accolades <code>{}</code>.
    <b>Chemin vers les options</b> : dans cet exemple, la liste des options est dans une clé nommée <code>books</code>. Le chemin vers les options est donc <code>books</code>. Il se peut que le tableau d'options soit directement à la "racine" des résultats, auquel cas on aura pas besoin de préciser de chemin.
    <b>Chemin vers le label</b> : dans chaque option de la liste <code>books</code>, le chemin vers le label est <code>title</code>. C'est le titre de chaque livre, qui sera affiché en tant qu'option de la liste déroulante.
    <b>Chemin vers la valeur</b> : dans chaque option, le chemin vers la valeur est ici <code>isbn</code>. Le but est d'avoir une valeur unique pour chaque élément (si jamais le label est déjà différent pour chaque élément, on peut remettre le chemin vers le label dans cette option).

    <b>EXEMPLE AVANCÉ</b>

    La source externe peut renvoyer des données avec plus de niveaux. Dans ce cas on utilisera des <code>.</code> pour descendre de niveau en niveau, par exemple :
    <pre>
    {
        "store": {
            "books": [
                {
                    "isbn": "0-553-21311-3",
                    "metadata": {
                        "author": "Herman Melville",
                        "category": "fiction",
                        "title": "Moby Dick"
                    },
                    "price": 8.99,
                },
                {
                    "isbn": "0-395-19395-8",
                    "metadata": {
                        "author": "J. R. R. Tolkien",
                        "category": "fiction",
                        "title": "The Lord of the Rings"
                    },
                    "price": 22.99,
                }
            ]
        }
    }
    </pre>
    <b>Chemin vers les options</b> : <code>store.books</code>
    <b>Chemin vers le label</b> : <code>metadata.title</code>
    <b>Chemin vers la valeur</b> : <code>isbn</code>
AdvancedSelect:
  noOptions: Pas d'options.
  sourceError: Une erreur est survenue, veuillez réessayer.
  typeToSearch: Tapez pour rechercher.
  typeAtLeastNbChars: Tapez au minimum {{minChars}} caractères.
AdvancedToComparePage:
  back: Retour à la liste
  title: "🔱 Comparaison avancée"
  description: Comparez finement les réponses des différents répondants (sensibilité à la casse, typo, etc..). Sert à éviter les itérations et relectures éventuellement inutiles
  empty: Les champs à comparer apparaitront ici.
AudioPlayer:
  error:
    description: Erreur de chargement du fichier
PDFViewer:
  error:
    description: Erreur de chargement du PDF
IframeViewer:
  error:
    description: Iframe lien incorrect
PdfOcrViewer:
  previousPage: Page précédente
  nextPage: Page suivante
  unzoom: Dézoomer
  zoom: Zoomer
  rotateLeft: Faire pivoter vers la gauche
  selectedValueNotFound: Valeur sélectionnée non trouvée dans les options disponibles
  forField: pour le champ
  error:
    description: Erreur de chargement du PDF
BlockForm:
  block: Groupe
  name: Nom du groupe
  foldable: Rétractable
  duplicable: Duplication autorisée
  showIncrement: Afficher l'incrément
  iterativeBackground: Nuancer les itérations
  maxRows: Hauteur max.
  color: Couleur de fond
  rowsRange: Nombre d'itérations
  insertAfter: Insérer après ce bloc
  delete: Supprimer ce bloc
BlockSortingRulesTemplate:
  addRule: "Ajouter une règle"
  empty: "Aucune règle pour ce groupe."
  error:
    duplicate: "Ce champ est déjà contenu dans unerègle."
    mustBeInBlock: 'Le champ doit appartenir au groupe "{{ block }}".'
ContributeCloseButtonTemplate:
  back: Retour
  error: 'Erreur lors de la libération de la tâche "{{ message }}".'
  alert: "Vous opérez sur la tache depuis plus de {{ startedAt }}, êtes vous toujours là ? Sans réponse de votre part la tâche sera libérée d'ici 30 secondes."
  alertLabel: "Oui"
CertificationPage:
  published: Réponse de référence publiée.
ContributePage:
  backAction: Retour sur
  answerError:
    description: Une erreur est survenue lors de la soumission de votre tâche. Veuillez réessayer ou contacter notre support.
  noTaskError:
    description: Vous avez pris part à toutes les contributions sur ce projet.
  noCertificationError:
    description: Vous avez répondu à toutes les questions de cette certification.
ContributeDonePage:
  title: Contribution enregistrée.
  quit: Quitter
  newTask: Nouvelle tâche
ContributeFormErrorModal:
  title: Erreurs de validation
  description: Il y a des erreurs de validation sur le formulaire. Corrigez les erreurs ci-dessous avant de soumettre à nouveau.
  button: Corriger
  error: "Erreur #{{ count }}"
  rowError: "Erreur #{{ count }} (ligne #{{ row }})"
  forceValidation: Je souhaite tout de même valider ma réponse
AdvancedSelectField:
  placeholder: "Cherchez et ajouter"
DrawerContentBlocks:
  title: "🔁 Ajouter un groupe !"
  description: "Pour plus de lisibilité ou pour dupliquer facilement les informations, glissez-déposez puis ajuster sur les champs que vous souhaitez grouper."
DrawerContentBlocksSortingPage:
  empty: "Vous n'avez aucun groupe."
  title: "Règles de tri des groupes"
  description: "Sélectionnez des ensembles de champs pour la comparaison des groupes."
DrawerContentInfo:
  title: "🔑 Indication de réalisation"
  description: "Personnalisez les instructions données aux opérateurs pour réaliser au mieux le projet. Ajoutez une vidéo, une image, ou un lien vers un tutoriel... Ils pourront y accéder en cliquant sur "
DrawerContentQuality:
  title: "👋 Options Qualité"
  description: "Fixez les règles de validation du formulaire pour obtenir des saisies de qualité (permet également de gérer les options de comparaison dans le cas du multitraitement)"
DrawerContentRespondants:
  title: ""
  description: ""
DrawerIterationOverloadPage:
  title: Itérations additionnelles
  description: Définissez les cas pour lesquels vous souhaitez faire valider la réponse par plus de répondants que celui paramétré. Si les règles ci-dessous sont réalisées, alors un répondant de plus sera sollicité, même si les premiers sont d’accord entre eux
  newRule: Nouvelle règle
  empty: Aucune règle.
  newRuleLabel: Règle {{ count }}
DrawerContentStrategy:
  title: "🎯 Gestion des modalités de traitement"
  description: "Personnalisez le processus de traitement. En multitraitement par exemple, chaque tâche est effectuée par plusieurs opérateurs et revue automatiquement pour maximiser la qualité de la restitution"
DrawerContentNoCompare:
  title: ""
  description: "Champs à ne pas comparer."
DrawerContentToComparePage:
  title: Champs à comparer ensemble
  description: Ajoutez ici des champs à comparer ensemble.
  addRule: Ajouter une règle
  empty: Aucune règle.
  duplicate: Ce champ est déjà contenu dans unerègle.
  mustBeInBlock: Le champ doit être contenu dans un groupe.
  mustBeInSameBlock: Tous les champs d'une règle doivent appartenir au même groupe.
DrawerContentSettings:
  title: "👌 Réglages de votre formulaire"
  description: "Réglez ici les temps minimum et maximum autorisés, personnalisez le bouton de validation, etc."
DrawerFormControls:
  publish: Publier
  published: Publié
  savePristine: Enregistré
  saveDirty: Enregistrer
  missingRequired: "Les champs suivants sont requis pour publier un formulaire :"
  publishConfirm: Êtes-vous sûrs de vouloir publier votre formulaire ?
DrawerContentValidation:
  title: 🤝 Règles de validation
  description: Validez la cohérence des saisies effectuées à l'aide de formules de comparaison.
  newRule: Nouvelle Règle
  noRules: Aucune règle.
  newRuleName: "Règle #{{ count }}"
Dropdown:
  empty: (vide)
ContributeFormTemplate:
  addBlock: Ajouter
  clearBlock: Vider tout
  submit: "Répondre"
  hideFailedExecution: "{{ count }} règle(s) n'ont pas pu s'executer."
ContributeAnswerDetailTemplate:
  taskError: Une erreur est survenue
  task: "Tâche #"
  project: Projet
  priority: Priorité
  rate: Noter
  quality: Qualité
  validate: Valider
DrawerHeaderTitlePage:
  unnamed: "(sans nom)"
QualityNavTemplate:
  advancedToCompare: Comparaison avancée
  respondants: Répondants
  validation: Règles de validation
  noCompare: À ne pas comparer
  toCompare: À comparer ensemble
  blocksSorting: Tri des groupes
  keyboardShortcuts: Raccourci clavier
  iterationOverload: Surcharge d'itération additionnelle
QualitySelectTemplate:
  respondants: Répondants
  strategy: Statégie de revue
EditFieldTemplate:
  createField: Créer un nouveau champ
EditDataTemplate:
  createData: Créer un nouveau champs de données
EditPage:
  createButton: "Nouveau champ"
  drawerTitle: "👋 Créez votre premier champ de saisie !"
  drawerDescription: "Glissez-déposez pour ajouter un champ."
DataPage:
  createButton: "Champ de données"
  drawerTitle: "🙌 Ajouter votre premier input !"
  drawerDescription: "Glissez-déposez pour ajouter un champ."
Form:
  uniqueID: Identifiant
  label: Label
  edit: edit
  create: create
FormulaInput:
  prompt:
    LITERAL_DATE: "Entrez une date valide au format (aaaa-mm-jj)"
    LITERAL_STRING: "Entrez une chaine de caractères :"
    LITERAL_NUMBER: "Entrez une chaine de caractères :"
FormulaField:
  invalidSyntax: Syntaxe Invalide
FormulaToken:
  sumOf: "SOMME des"
  countOf: "NOMBRE de"
  forEach: "pour tous les"
  forEachIter: "A chaque"
  forAll: "Pour tout le formulaire"
HideRuleFragment:
  enabled: Cacher sous conditions
  error:
    selfReference: Un champ ne peut se référencer lui-même.
    subFieldReference: Un groupe ne peut référencer un champ enfant.
    forbidden: Référence impossible sur ce champ duplicable

InfoPage:
  title: Indications de réalisation
IterationOverloadRule:
  minMatch: Itérations pour valider
  formulaPlaceholder: Comparaison simple
  instructions: Ajoutez une règle de comparaison simple avec un champ et une valeur fixe.
  deliveryAnswer: Choix de livraison
  errors:
    alreadyContained: Ce champ est déjà référencé.
    wrongType: Ce type de champ n'est pas accepté.
    isMulti: Le champ selectionné doit être configuré en mode "Réponse simple"
KeyboardShortcutsForm:
  key: 'Touche "{{ key }}"'
  addShortcut: Ajouter raccourci
  addMultiShortcut: Ajouter raccourci choix
  value: Valeur
  noName: "Sans nom #{{ i }}"
  mcq:
    multiMode:
      set: Cocher
      unset: Décocher
      toggle: Inverser
  select:
    multiMode:
      set: Sélectionner
      unset: Déselectionner
      toggle: Inverser
MCQ:
  other: Autre
NoCompare:
  placeholder: Cliquez sur un champ pour l'ajouter ...
RangeField:
  min: Min
  max: Max
SettingsForm:
  averageDuration: Temps moyen
  minimumDuration: Temps minimum
  keySkill: Compétence clé
  subdivide: Lotir
  submitLabel: Bouton valider
  allowError: Autoriser la validation d'erreurs
  enterToValidate: Entrer pour soumettre
  prefillInputs: Pré-remplir les champs de saisie
  showFormTitle: Ajouter le titre du formulaire sur la tâche
  fontSize: Taille de la police
  disableBrowserShortcuts: Désactiver les raccourcis du navigateur
  gridSize: Taille de la grille
PreviewPage:
  back: Retour
UploadInput:
  openDialog: Parcourir
  pending: Téléchargement en cours ...
  uploadFailed: "Le téléchargement du fichier a échoué : {{ message }}"
  errors:
    belowMin: "Minimum autorisé {{ size }}mo."
    aboveMax: "Maximum autorisé {{ size }}mo."
QualityStrategyForm:
  answerMultiOptions:
    true: Envoyer la meilleure réponse
    false: Envoyer toutes les réponses
  answerProofReadingOptions:
    allAnswer: Envoyer toutes les réponses
    lastAnswers: Envoyer la réponse de la dernière relecture
  bestAnswerOnly: Envoyer la meilleure réponse
  samplePercent: Échantillon intelligent
  matchingCount: Nombre de répondants
  iterationCount: Nombre max. d'itérations
  indeterminateMode: En cas d'indétermination
  respondentPerTask: Répondants / Tâche
  proofreadingCount: Nombre de relectures
  readerInstructions: Instructions de relecture
  sendingAnswer: Envoie de réponse
  topOptions:
    panel: Panel
    multi: Multi-Traitement
    proofreading: Relecture
    simple: Saisie Simple
  isComplex:
    left: Saisie simple
    right: Autres options
  sampleOptions:
    sample: Échantillon
    multi: Multi
  undeterminateOptions:
    bestAnswer: Revue automatique
    manual: Revue manuelle
RegexRuleFragment:
  regex: Expression régulière
  errorMessage: Message d'erreur
  regexHelp: Testez votre regex
  regexHelpLink: regex101.com
ValidationRule:
  executeWhenHidden: Exécuter même si les champs sont cachés
  formulaPlaceholder: Formule ...
  errorMessage: Message d'erreur
  errorMessagePlaceholder: La valeur est incorrecte.
ViewerFragment:
  error:
    fixedModeItemsBelow: Retirez les boites sous le viewer pour pouvoir activer le mode ancré.
Copy: Copier
WasCopied: Copié !

# Keys linked to fields typology
field:
  options:
    information: Information
    required: Obligatoire
    charsRange: Nombre de caractères
    wordsRange: Nombre de mots
    allowedDecimals: Entier / Décimales
    integer: Entier
    decimals: Décimales
    optionalUnit: Unité optionnelle
    valueRange: Valeurs
    longitudeRange: Taille de la longitude
    latitudeRange: Taille de la latitude
    values: Valeurs
    selectTypology: Type
    domains_accepted: Domaines acceptés
    domains_rejected: Domaines refusés
    multi: Plusieurs réponses possibles
    allowOther: Choix « Autres » possible
    autoselect: Préselectionner la 1ère valeur
    activateLabelValue: Activer des Valeurs
    horizontal: Affichage horizontal
    choices: Choix
    whitelist: Whitelist
    blacklist: Blacklist
    datetimeFormat: Format date & heures
    timeRange: Heures min & max
    dateRange: Dates min & max
    onlyCountry: Pays uniquement
    defaultFrance: France par défaut
    allowedExtentions: Extensions autorisées
    imagesOnly: Fichier image
    sizeRange: Taile du fichier (mo)
    choicesRange: Nombre de réponses
    capitalized: Majuscule en début de mot
    injectChoices: Fournir les choix en tant que donnée
    injectSeparator: Séparateur
    injectSeparatorValueLabel: Séparateur Label Valeur
    separatorData: Séparateur des données fournies
    Errorseparator: Utilisez le séparateur
    labelValuePlaceholder: LABEL_1@@VALEUR_1  LABEL_2@@VALEUR_2 LABEL_3@@VALEUR_3
    rib: RIB
    options:
      date: Date
      time: Heure
      datetime: Date & Heure
    remoteOptionsEnabled: Source externe
    remoteOptions:
      url: URL du flux
      authorization: HTTP Authorization
      pathOptions: Chemin vers les options
      pathLabel: Chemin vers le label
      pathValue: Chemin vers la valeur
      addSupplierIDInHeaders: Ajouter l'id au header
      queryMode: Mode recherche
      queryModeInstructions: Permet un mode recherche dynamique sur la source externe. L'élément {query} dans l'URL sera remplacé par le texte saisit.
      minChars: Caractères minimum
    hideRich: Ne pas afficher le texte riche
  text_short:
    label: Texte court
  email:
    label: Email
  coordinates_gps:
    label: Coordonnées GPS
  number:
    label: Champ numérique
  mcq:
    label: QCM & QCU
  phonenumber:
    label: Numéro de téléphone
  text:
    label: Texte
  url:
    label: Url
  select:
    label: Liste déroulante
  datetime:
    label: Date
  address:
    label: Adresse
  file:
    label: Upload document
  rib:
    label: IBAN/RIB

# Keys linked to fields data
data:
  options:
    content: Contenu
    link: Lien
    information: Information
    fixedMode: Mode ancré
    perserveHeight: Préserver la hauteur
    perserveWidth: Préserver la longueur
  data_text:
    label: Texte
    numeric: "Comparaison numérique"
  data_numeric:
    label: "Texte"
  data_embed:
    label: Viewer
  data_url:
    label: Lien formaté
  data_video:
    label: Vidéo
  data_audio:
    label: Audio
  data_image:
    label: Image
  data_iframe:
    label: Iframe
  data_pdf_ocr:
    label: PDF OCR

comparisonRules:
  options:
    case_sensitive: Sensible à la casse
    space_sensitive: Sensible aux espaces
    special_char_sensitive: Sensible aux caractères spéciaux
    accent_sensitive: Sensible aux accents
    distance: Écart
    deliveryAnswer: Quelle réponse envoyer
    timeunit: Unité de temps
    options:
      1: "Meilleure reconstitution"
      2: "Réponse Normalisée"
      3: "Toutes les itérations"
      4: "Toutes les itérations matchant au minimum d’itérations requises"
      5: "Toutes les itérations matchant au minimum 2 fois"
      6: "Moyenne / Milieu"
      7: "Meilleur Contributeur"
      8: "Meilleure réponse validant la/les condition(s)"
      9: "Vide"
      second: Seconde
      minute: Minute
      hour: Heure
      day: Jour
      month: Mois
      year: Année

error:
  default:
    title: "Une erreur s'est produite"
    body: "Veuillez réessayer dans quelques instants."

# Keys linked to FieldError
FieldError:
  required: "Ce choix est obligatoire."
  not_enough_chars: "Pas assez de caractères (min {{ value }})."
  too_many_chars: "Trop de caractères (max {{ value }})."
  not_enough_words: "Pas assez de mots (min {{ value }})."
  below_minimum: "La valeur est trop petite (min {{ value }})."
  above_maximum: "La valeur est trop grande (max {{ value }})."
  too_many_words: "Trop de mots (max {{ value }})."
  not_integer: "La valeur {{ value }} n'est pas un entier."
  not_number: "La valeur {{ value }} n'est pas un nombre."
  denied_domains: "Le domaine {{ value }} n'est pas autorisé."
  bad_format_email: "Le format de l'adresse mail n'est pas valide."
  bad_format_phone: "Le format du numéro de téléphone n'est pas valide."
  time_below_minimum: "L'heure ne peut être inférieure à {{ value }}."
  time_above_maximum: "L'heure ne peut être supérieure à {{ value }}."
  date_below_minimum: "La date ne peut être inférieure à {{ value }}."
  date_above_maximum: "La date ne peut être supérieure à {{ value }}."
  bad_format_url: "Ceci n'est pas une URL valide."
  invalid_address: "L'adresse postale est invalide."
  invalid_syntax: "Syntaxe invalide."
  regex_not_match: "La valeur doit respecter le format {{ value }}"
  iteration_rule_syntax_invalid: "Le format doit respecter <champ> <opérateur> <valeur>."
  not_capitalized: "La valeur doit comporter une majuscule au début de chaque mot."
  below_min_rows: "Nécessite au moins {{ value }} ligne(s)."
  above_max_rows: "Nécessite au plus {{ value }} ligne(s)."
  below_min_choices: "Nécessite au moins {{ value }} choix."
  above_max_choices: "Nécessite au plus {{ value }} choix."
  invalid_rib: "RIB/IBAN invalide"
  invalid_date: "La date n'est pas valide"

form:
  errors:
    title: Titre du formulaire
    errorChoicesSelectorMcq: Mauvaise syntaxe dans les choix du selecteur ou qcm
    averageDuration: Paramètres > Durée maximale
    minimumDuration: Paramètres > Durée minimum
    respondentPerTask: Qualité > Répondants par tâche
    missingBlockSortingRules: 'Le groupe "{{block}}" doit avoir une règle de tri.'
    iterationOverloadOutOfRange: 'Le paramètre "Itération" de la règle de surcharge additionnelle "{{ rule }}" est en dehors de la plage d''itérations définie en stratégie qualité.'

popover:
  anchorEdit:
    title: Champs réponses
    text: "Ajoutez les champs que vous souhaitez faire saisir : Texte, Date, Adresse, etc."
    svg: undraw_approve
  anchorReload:
    title: Les documents à saisir
    text: "Ajoutez les documents et informations que vous mettrez à disposition des opérateurs pour effectuer leurs saisies : pdf, images, vidéos, texte, etc.."
    svg: undraw_collection
  anchorBlocks:
    title: Création de groupes
    text: Groupez certains champs entre eux pour simplifier les saisies multiples ou répétitives.
    svg: undraw_content
  anchorInfo:
    title: Infos additionnelles
    text: Donnez toutes les informations utiles aux opérateurs pour les aider lors de la saisie.
    svg: undraw_reviewed
  anchorStrategy:
    title: Stratégie de revue
    text: Déterminez les modalités de traitements de vos tâches pour assurer une qualité optimale (multitraitement, relecture, échantillonnage, etc.)
    svg: undraw_Taking_notes
  anchorQuality:
    title: "Options Qualité"
    text: "Fixez les règles de validation du formulaire pour obtenir des saisies de qualité (permet également de gérer les options de comparaison dans le cas du multitraitement)"
    svg: undraw_update
  anchorSettings:
    title: Paramètres généraux
    text: Réglez ici les temps minimum et maximum autorisés, personnalisez le bouton de validation, etc.
    svg: undraw_preferences

toast:
  compare: Ce champ est référencé dans les champs à comparer ensemble / ne pas comparer
  hideIf: Ce champ est référencé dans la règle "Masquer sous conditions" du champ "{{ fieldName }}"
  sorting: "Ce champ est référencé dans la règle de tri du groupe {{sortingName}}"
  rule: Ce champ est référencé dans la règle masquer sous condition du champ {{fieldName}}
ShortcutFragment:
  shortcut: Accès court
regex:
  enabled: Validation par expression regulière
